/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientNotes = sqliteTable('patient_notes', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  title: text('title'),
  body: text('body'),
  note_type: text('note_type'),
  visibility: text('visibility'),
  alert_level: text('alert_level'),
  author_user_id: text('author_user_id'),
  author_name: text('author_name'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
